import { View } from '@/types';

const MACRO_VIEW_ID = '12';

export const isMacroView = (view: View) => view.id === MACRO_VIEW_ID;
